import themes from '../constants/themes';

export default function ThemesService(ipCookie, $location) {
    'ngInject';

    return {
        applyTheme,
        applyThemeFromRequest,
    };

    function applyTheme(theme) {
        const rootNode = document.querySelector(':root');

        rootNode.style.setProperty('--main-color-var', theme.main);
        rootNode.style.setProperty('--heading-color-var', theme.heading);
        rootNode.style.setProperty('--button-active-color-var', theme.active);
        rootNode.style.setProperty('--logo-path-var', 'url(\'' + theme.logo + '\')');
    }

    function applyThemeFromRequest() {
        if (checkAndApply($location.search().brand)) {
            return;
        }

        checkAndApply(ipCookie('userTheme'));
    }

    function checkAndApply(themeName) {
        if (themeName && themes[themeName]) {
            const theme = themes[themeName];
            applyTheme(theme);

            return true;
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/themes-service.js